export const phoneValidations = /^(48)\d+$/
